::ng-deep particle-activity-filter-project-selector{height:100%}::ng-deep particle-activity-filter-project-selector particle-tree-selector .tree-selector-height{height:100%!important}
/*# sourceMappingURL=activity-filter-project-selector.component-W3PGTJVP.css.map */
